import React, {useEffect, useState} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header'; 
import Checkbox from '../../Components/TACheckbox';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Spinner  } from "react-awesome-spinners";



export default ({InfIdConta, InfIdUse, IdConta, IdUse, Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar, setAddList}) => {
const [Nome, setNome] = useState("");
const [Titulo, setTitulo] = useState("Criar Grupo");
const [Valor, setValor] = useState("nulo");
const [Alert1, setAlert1] = useState("");
const [AlertTipo1, setAlertTipo1] = useState("");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [permissoes, setPermissoes] = useState(InfIdConta.menuFun);


  useEffect(() => {
         

         }, [permissoes])

const togglePermissao = (menu, key, subKey = null) => {
  setPermissoes((prev) => {
    const novo = { ...prev, [menu]: { ...prev[menu], Btn: { ...prev[menu].Btn } } };

    if (subKey) {
      novo[menu].Btn[subKey] = !prev[menu].Btn[subKey];
    } else {
      novo[menu][key] = !prev[menu][key];
    }

    return novo;
  });
};
   

  const criando = ()=>{
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
    if (navigator.onLine) {
         setLoading(true)       
       Api.TACriarGruposClientes(Dados, Nome, permissoes, InfIdConta, InfIdUse, IdConta, IdUse, setAlertTipo, setAlert,  setLoading, setMsgErro, setAddList);

      
     } else {
       setAlert("Sem Internet");
       setAlertTipo("danger");
     }
  }else {
    setMsgErro("Coloque o Nome do Grupo")
  }
} 

 
  const cancelar = ()=>{
    setAlertTipo1("")
    setAlert1("")
}
 
  

        return (
            <>
<div className="content-wrapper">
        {Alert1 !== " " && AlertTipo1 === "success" &&
                  <SweetAlert  success title={Alert1} onConfirm={cancelar} onCancel={cancelar} />
                }

            {Alert1 !== " " && AlertTipo1 === "danger" &&
                  <SweetAlert  danger title={Alert1} confirmBtnBsStyle="danger" onConfirm={cancelar} onCancel={cancelar} />
                }
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                      
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-columns" /> Permissões 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                            <>
                              <Spinner 
                              size={64}
                              color={"#5d0bf7"}
                              sizeUnit={'px'} 
                              /><br />
                              </>
                              :
                              <>
                            <div className="col-12">
                                <Butao 
                                style={"btn .btn-sm btn-info"}
                                titulo={"Salvar"}
                                onClick={()=>criando()}
                                />  
                            </div><br />
                            
                              {MsgErro !== "" &&
                            <>
                            <div class="alert alert-danger alert-dismissible">
                          
                          <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                          {MsgErro}
                        </div>
                            
                            </>
                            }
                            </>
                            }
                    <strong>Digite o Nome do Grupo:</strong><br />
                    <div className="input_cadatro">
                              <Campo 
                                  type={"text"}
                                  placeholder= {"Digite Nome do Grupo"}
                                  icon={"fas "}
                                  value={Nome}
                                  onChange={e=>setNome(e.target.value)}
                                  mask={null}
                                />

                            </div> 
                            
                 
                  </address>
                </div>
               <div className="row mt-4">
              {Object.keys(permissoes).map((menu) => (
               
                <div key={menu} className="col-12 col-sm-6 col-md-4 mb-3">
                  <div className="card p-2 shadow-sm">
                    <h5>{menu}</h5>
                    <Checkbox
                      label="Vizualizar_Menu"
                      checked={permissoes[menu].Ver}
                      onChange={() => togglePermissao(menu, "Ver")}
                    />
                    {Object.keys(permissoes[menu].Btn).map((btn) => (
                      <Checkbox
                        key={btn}
                        label={btn}
                        checked={permissoes[menu].Btn[btn]}
                        onChange={() => togglePermissao(menu, "Btn", btn)}
                      />
                    ))}
                    
                  </div>
                </div>
                 
              ))}
               </div>
                
                       
                      
                     
                   
              </div>
              <div className="row no-print">
              
               
             
              </div>
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}